import React from "react";
import Select from "react-select";
import { components } from "react-select";
import { CircularAvatar } from "../../commons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { NewDownloadIcon } from "../../../assets/images";
import { RecurringJobReportListType } from "../../../redux/jobs/jobsType";

export type DropDownUserType = {
  value: number | null;
  label: string;
};
type AppProps = {
  setManagerOffset: React.Dispatch<React.SetStateAction<number>>;
  setManagerText: React.Dispatch<React.SetStateAction<string>>;
  managerLimit: number;
  managerFetching: boolean;
  finalManagerList: any;
  manager: DropDownUserType;
  setManager:  React.Dispatch<React.SetStateAction<DropDownUserType>>;
  setOffset: React.Dispatch<React.SetStateAction<number>>;
  setLimit: React.Dispatch<React.SetStateAction<number>>;
  limit: number;
  userFetching: boolean;
  finalUserList: any;
  currentlyResposible: DropDownUserType;
  setCurrentlyResposible: React.Dispatch<React.SetStateAction<DropDownUserType>>;
  setText: React.Dispatch<React.SetStateAction<string>>;
  handleSubmitData: () => void;
  recurringJobReportList: RecurringJobReportListType[] | [];
  handlePrepareDownload: () => void;
  handleCurrentlyResponsibleChange:(data:any)=>void;
  handleManagerChange:(data:any)=>void;
  isDownloadRecurringJobReportPresent:boolean;
};

const RecurringJobReportHeader = ({
  setManagerOffset,
  setManagerText,
  managerLimit,
  managerFetching,
  finalManagerList,
  manager,
  setManager,
  setOffset,
  setLimit,
  limit,
  userFetching,
  finalUserList,
  currentlyResposible,
  setCurrentlyResposible,
  setText,
  handleSubmitData,
  recurringJobReportList,
  handlePrepareDownload,
  handleCurrentlyResponsibleChange,
  handleManagerChange,
  isDownloadRecurringJobReportPresent
}: AppProps) => {
  const checkManagerBottom = () => {
    setManagerOffset((prv: any) => prv + managerLimit);
  };
  const checkUserBottom = () => {
    setOffset((prv: any) => prv + managerLimit);
  };

  const Option = (props: any) => {
    const { data } = props;
    const isSelectOption = data?.label === "Select..";
    if (!isSelectOption) {

    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  } else{
     return (
            <components.Option {...props}>
              <span style={{ fontWeight: "500", fontSize: "16px" ,marginLeft:'17px'}}>
                {data.label}
              </span>
            </components.Option>
          );
  }
  };
  return (
    <>
      <div className="d-flex pt-3 pl-3 align-items-center">
        <div className="col-md-3 pr-0">
          <div className="form-group">
            <div className="col-md-12 p-0 pr-1">
              <label htmlFor="employeeId">Manager </label>
              <Select
                options={
                  finalManagerList?.length > 0
                    ? [{ label: "Select..", value: null }, ...finalManagerList]
                    : [{ label: "Select..", value: null }]
                }
                value={manager}
                components={{ Option }}
                onChange={(value: any) => handleManagerChange(value)}
                isSearchable={true}
                isLoading={managerFetching}
                onMenuClose={() => {
                  setManagerOffset(0);
                }}
                onMenuScrollToBottom={checkManagerBottom}
                onInputChange={(e) => {
                  setManagerText(e);
                }}
              />
            </div>
          </div>
        </div>
        <div className="col-md-3 pr-0">
          <div className="form-group">
            <div className="col-md-12 p-0 pr-1">
              <label htmlFor="employeeId">Currently responsible </label>
              <Select
                options={
                  finalUserList?.length > 0
                    ? [{ label: "Select..", value: null }, ...finalUserList]
                    : [{ label: "Select..", value: null }]
                }
                value={currentlyResposible}
                components={{ Option }}
                onChange={(value: any) =>handleCurrentlyResponsibleChange(value)
                }
                isSearchable={true}
                isLoading={userFetching}
                onMenuClose={() => {
                  setOffset(0);
                }}
                onMenuScrollToBottom={checkUserBottom}
                onInputChange={(e) => {
                  setText(e);
                }}
              />
            </div>
          </div>
        </div>
        <div className="col-md-1">
          <button
            className="btn btn-primary mt-2 pt-2 pb-2"
            onClick={handleSubmitData}
            disabled={!manager?.value && !currentlyResposible?.value}
          >
            Apply
          </button>
        </div>
       
        {isDownloadRecurringJobReportPresent &&
          <div className="pr-2">
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 250 }}
              overlay={
                <Tooltip id="button-view-download-invoice">
                  Download Reports
                </Tooltip>
              }
            >
              <button
                className="btn form-control mt-1"
                style={{ border: "1px solid #bfcbe1" }}
                onClick={() => handlePrepareDownload()}
                disabled={!recurringJobReportList?.length ||!manager?.value && !currentlyResposible?.value}
              >
                <img src={NewDownloadIcon} alt="download icon" />
              </button>
            </OverlayTrigger>
          </div>
        }
      </div>
    </>
  );
};

export default RecurringJobReportHeader;
